import { render, staticRenderFns } from "./contest-student.vue?vue&type=template&id=3850a5f3&scoped=true"
import script from "./contest-student.vue?vue&type=script&lang=js"
export * from "./contest-student.vue?vue&type=script&lang=js"
import style0 from "./contest-student.vue?vue&type=style&index=0&id=3850a5f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3850a5f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3850a5f3')) {
      api.createRecord('3850a5f3', component.options)
    } else {
      api.reload('3850a5f3', component.options)
    }
    module.hot.accept("./contest-student.vue?vue&type=template&id=3850a5f3&scoped=true", function () {
      api.rerender('3850a5f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-student.vue"
export default component.exports